export const INFO_DATA_KEY = "info_data";
